import React from "react";
import { newModelWith } from "../reducers/models";

export function hasNoDerivativeDescription(derivativeDescription) {
    return !derivativeDescription || derivativeDescription.trim().length === 0;
}

export const USER_ENTERED_DATE_TIME_PROP_TYPES = React.PropTypes.shape({
    asEntered: React.PropTypes.shape({
        date: React.PropTypes.string,
        time: React.PropTypes.string,
        timezone: React.PropTypes.string
    }),
    instant: React.PropTypes.string
});

export function recorderFieldValuesWith(values = {}) {
    const schema = {
        communicatedVia: React.PropTypes.string,
        clients: React.PropTypes.arrayOf(React.PropTypes.shape({
            emailAddress: React.PropTypes.string

        })),
        contactGroups: React.PropTypes.arrayOf(React.PropTypes.object),
        disseminatedOn: USER_ENTERED_DATE_TIME_PROP_TYPES,
        sendEmail: React.PropTypes.bool,
        recommendations: React.PropTypes.arrayOf(React.PropTypes.shape({
            searchUniverse: React.PropTypes.string,
            legs: React.PropTypes.arrayOf(React.PropTypes.shape({
                instrument: React.PropTypes.shape({
                    name: React.PropTypes.string,
                    symbol: React.PropTypes.string,
                    instrumentId: React.PropTypes.string
                }),
                direction: React.PropTypes.string,
                derivativeDescription: React.PropTypes.string,
                suppliedPrice: React.PropTypes.string,
                targetPrice: React.PropTypes.string
            })),
            producedOn: USER_ENTERED_DATE_TIME_PROP_TYPES,
            validityPeriod: React.PropTypes.string,
            reasoning: React.PropTypes.string,
            hasConflictOfInterest: React.PropTypes.string,
            conflictOfInterestDescription: React.PropTypes.string
        }))
    };
    const defaults = {
        communicatedVia: "",
        sendEmail: true,
        clients: [],
        contactGroups: [],
        disseminatedOn: null,
        recommendations: []
    };

    return newModelWith(values, defaults, schema);
}

export function recommendationFieldValuesWith(values = {}) {
    const schema = {
        searchUniverse: React.PropTypes.string,
        legs: React.PropTypes.arrayOf(React.PropTypes.object),
        producedOn: USER_ENTERED_DATE_TIME_PROP_TYPES,
        validityPeriod: React.PropTypes.string,
        reasoning: React.PropTypes.string,
        hasConflictOfInterest: React.PropTypes.string,
        conflictOfInterestDescription: React.PropTypes.string
    };
    const defaults = {
        legs: []
    };

    return newModelWith(values, defaults, schema);
}

export function recommendationLegFieldValuesWith(values = {}) {
    const schema = {
        instrument: React.PropTypes.shape({
            name: React.PropTypes.string,
            symbol: React.PropTypes.string,
            instrumentId: React.PropTypes.string
        }),
        direction: React.PropTypes.string,
        derivativeDescription: React.PropTypes.string,
        suppliedPrice: React.PropTypes.string,
        targetPrice: React.PropTypes.string
    };
    const defaults = {};

    return newModelWith(values, defaults, schema);
}

export function instrumentWith(values = {}) {
    const schema = {
        name: React.PropTypes.string,
        symbol: React.PropTypes.string,
        instrumentId: React.PropTypes.string,
        quoteId: React.PropTypes.string, // Deprecated, only used by the single recommendation recorder screen
        indicativePrice: React.PropTypes.number,
        recommendableType: React.PropTypes.string,
        userProvided: React.PropTypes.bool,
        recommendable: React.PropTypes.object
    };
    const defaults = {
        name: "",
        symbol: "",
        instrumentId: "",
        quoteId: "",
        indicativePrice: null,
        recommendableType: null,
        userProvided: false,
        recommendable: null
    };

    return newModelWith(values, defaults, schema);
}

export function disclosureWith(values = {}) {
    const schema = {
        direction: React.PropTypes.string,
        disclosureUri: React.PropTypes.string,
        disclaimers: React.PropTypes.object,
        disseminatedOn: React.PropTypes.string,
        instrumentSymbol: React.PropTypes.string,
        numberOfAttempts: React.PropTypes.number,
        lastDifferingRecommendation: React.PropTypes.object,
        numberOfAttemptsForLastDifferingRecommendation: React.PropTypes.number
    };
    const defaults = {
        disclaimers: {},
        numberOfAttempts: 0,
        lastDifferingRecommendation: {},
        numberOfAttemptsForLastDifferingRecommendation: 0
    };

    return newModelWith(values, defaults, schema);
}



/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/models.js
 **/